import { Close } from '@mui/icons-material'
import classNames from 'classnames'
import { IconButton } from 'ui'

import style from './ModalCloseButton.module.scss'

type TModalCloseButton = {
  onClose: () => void
  showOnMobile?: boolean
  className?: string
}

// кнопка закрытия модального окна
export function ModalCloseButton({
  onClose,
  className,
  showOnMobile = false,
}: TModalCloseButton) {
  return (
    <IconButton
      onClick={onClose}
      className={classNames(style.closeBtn, className, {
        [style.showOnMobile]: showOnMobile,
      })}
      data-testid='modal-close-btn'
    >
      <Close />
    </IconButton>
  )
}
